export default "__VITE_ASSET__CONoD6MZ__"